import script from "./slider-widget-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./slider-widget-ly.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__